import { ExternalLink, ExternalLinks } from './external-links-base'

interface ExternalLinksComponentProps {
  suumoLink?: string
  athomeLink?: string
  homesLink?: string
}

const ExternalLinksComponent = ({
  suumoLink,
  athomeLink,
  homesLink,
}: ExternalLinksComponentProps) => {
  // 全てのリンクがない場合は何も表示しない
  if (!suumoLink && !athomeLink && !homesLink) {
    return null
  }

  return (
    <ExternalLinks>
      {suumoLink && (
        <ExternalLink
          href={suumoLink}
          target="_blank"
          rel="noreferrer"
          imageHeight="40px"
        >
          <img src="/image/suumo.png" alt="SUUMO" />
          <img src="/image/arrow-right-gray.svg" alt="詳細を見る" />
        </ExternalLink>
      )}
      {athomeLink && (
        <ExternalLink
          href={athomeLink}
          target="_blank"
          rel="noreferrer"
          imageHeight="40px"
        >
          <img src="/image/athome.png" alt="AtHome" />
          <img src="/image/arrow-right-gray.svg" alt="詳細を見る" />
        </ExternalLink>
      )}
      {homesLink && (
        <ExternalLink
          href={homesLink}
          target="_blank"
          rel="noreferrer"
          imageHeight="40px"
        >
          <img src="/image/homes.png" alt="Homes" />
          <img src="/image/arrow-right-gray.svg" alt="詳細を見る" />
        </ExternalLink>
      )}
    </ExternalLinks>
  )
}

export default ExternalLinksComponent
